/* eslint-disable import/prefer-default-export */

var POPPER_PLACEMENTS = ['top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-start', 'bottom', 'bottom-end', 'left-start', 'left', 'left-end'];

/* Popper offset documentation: https://popper.js.org/docs/v2/modifiers/offset/
 * Reminder that the 'placement' prop influences the direction of skidding and distance
 */
var SUBMENU_POPPER_OFFSET = [0, 0];
var FLYOUT_POPPER_OFFSET = [0, 6];
var TOOLTIP_POPPER_OFFSET = [0, 12]; // Distance of 12 is 6px for the half of the arrow's hypotenuse + 6px for the actual distance

var FOCUS_RING_WIDTH = 4;

export { FLYOUT_POPPER_OFFSET, FOCUS_RING_WIDTH, POPPER_PLACEMENTS, SUBMENU_POPPER_OFFSET, TOOLTIP_POPPER_OFFSET };
